var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"grid"},_vm._l((_vm.count),function(i){return _c('div',{key:i})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }